import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

const OjieThumbsUpIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 732 732" {...props}>
      <path
        d="M396 5L400 7L410 18L422 35L430 51L435 66L437 85L456 73L472 64L489 56L510 49L531 44L538 43H560L573 47L582 54L590 63L597 75L601 88L602 94V104L599 118L594 130L588 139L598 147L604 155L608 164L609 169V185L606 199L602 208L600 212L608 220L615 233L617 242L616 255L612 266L606 277L598 287L586 299L578 306L579 310L587 323L595 338L603 359L609 381L614 413L615 425V458L612 483L607 505L600 526L590 548L580 565L569 581L556 597L544 610L532 622L521 631L504 644L483 657L459 669L435 678L414 684L393 688L373 690H340L319 688L296 684L271 677L247 667L229 657L210 644L196 633L185 623L177 616L164 602L151 585L140 567L133 552L129 539L126 521L115 474L111 452L109 433V421L112 402L118 377L127 350L136 330L146 312L158 295L169 283L181 271L199 258L220 246L245 234L252 231L238 223L231 217L218 200L210 186L202 169L199 164L209 159L224 154L233 152H253L263 155L272 161L284 174L295 186L307 201L312 210V212L324 209L322 204L313 188L307 173L304 159V147L307 120L290 111L282 105L273 93L268 82L266 74V60L270 49L276 39L285 30L297 23L306 20L311 19H330L346 23L360 29L367 33L380 21L396 5Z"
        fill="#F99D2D"
      />
      <path
        d="M396 5L400 7L410 18L422 35L430 51L435 66L437 85L456 73L472 64L489 56L510 49L531 44L538 43H560L573 47L582 54L590 63L597 75L601 88L602 94V104L599 118L594 130L588 139L598 147L604 155L608 164L609 169V185L606 199L602 208L600 212L608 220L615 233L617 242L616 255L612 266L606 277L598 287L586 299L578 306L568 314L550 328L532 339L513 347L497 352L489 354H466L450 350L436 343H432L419 353L409 362L403 367L414 366H439L457 368L473 373L486 380L493 386L496 391V397L495 398L485 397L465 390L454 388H420L398 393L380 400L373 403H366L363 400V389L370 376L380 363L391 351L398 344L409 335L419 328L417 323L411 313L406 302L403 293V286H401L394 278L387 271L376 263L363 250L355 237L350 224L349 219L347 168L345 155L341 144L335 136L321 127L305 119L290 111L282 105L273 93L268 82L266 74V60L270 49L276 39L285 30L297 23L306 20L311 19H330L346 23L360 29L367 33L380 21L396 5Z"
        fill="#020202"
      />
      <path
        d="M315 41H338L353 45L366 52L376 61L383 72L393 97L403 122L409 133L417 140L424 143L417 127V118L428 109L444 98L462 86L481 75L496 68L508 65L525 62H545L559 65L569 71L577 80L582 91L583 95V109L578 125L572 137L563 147L553 155L534 165L519 170L515 171H506L494 165L488 158L485 150V137L489 124L494 115L503 103L513 93L526 83L532 79H534L531 76H523L512 82L501 90L488 101L479 111L471 124L468 132V151L470 160L474 170L479 177L470 188L465 199L463 205V218L466 230L471 239L476 244L485 250L495 253V272L499 285L505 295L513 301L521 304H543L552 303L547 308L537 316L520 326L506 332L500 334L482 336H456L444 333L433 326L425 316L419 302L415 289L413 272L402 265L388 254L380 246L371 232L365 215L361 194L360 151L358 143L351 131L342 122L327 114L311 106L297 97L287 88L282 77V63L287 54L296 47L302 44L315 41Z"
        fill="#FDFDFD"
      />
      <path
        d="M221 384H237L250 388L260 394L267 400L274 410L278 418L280 429V443L277 455L270 466L263 474L252 481L242 485L235 486H221L208 482L197 475L188 466L183 458L178 443V428L182 414L189 403L198 394L210 387L221 384Z"
        fill="#010101"
      />
      <path
        d="M213 366H230L245 370L259 377L270 386L280 398L288 413L292 426L293 432V454L288 473L282 485L275 494L267 502L256 509L240 515L234 516H219L207 513L198 509L186 502L173 489L165 477L159 461L156 448V429L159 415L164 403L173 389L182 380L193 373L205 368L213 366ZM221 384L208 388L197 395L188 404L182 414L178 428V443L183 458L190 468L198 476L210 483L221 486H235L245 484L259 477L268 469L275 458L278 451L280 443V429L277 416L271 405L264 397L254 390L242 385L237 384H221Z"
        fill="#FDFCFB"
      />
      <path
        d="M436 511L442 512L446 517L447 519V528L444 538L438 548L429 558L422 565L412 572L393 582L375 588L364 590H338L318 586L306 581L298 575L292 566V559L296 555L317 554L337 551L364 545L389 536L413 525L428 516L436 511Z"
        fill="#010100"
      />
      <path
        d="M233 152H253L263 155L272 161L284 174L295 186L307 201L313 213L284 221L267 227L256 231L251 230L238 223L231 217L218 200L210 186L202 169L199 164L209 159L224 154L233 152Z"
        fill="#97C13C"
      />
      <path
        d="M579 158L583 160L588 170L590 177V191L586 204L580 215L573 223L563 230L550 235L542 237H510L494 233L485 226L481 217V205L484 196L487 191L494 192H516L527 189L543 183L558 175L569 167L579 158Z"
        fill="#FCFCFC"
      />
      <path
        d="M396 5L400 7L410 18L422 35L430 51L435 66L436 72V87L426 95L414 104L407 109L403 104L400 95L396 78L390 62L384 52L375 42L367 35L369 31L379 22L396 5Z"
        fill="#7F9F3D"
      />
      <path
        d="M590 231L593 232L598 244L599 249V262L595 270L587 277L575 283L559 288L553 289H538L526 286L520 283L514 276L511 268V253L536 251L555 246L576 238L590 231Z"
        fill="#FBFBFB"
      />
      <path
        d="M308 120L313 122L328 130L337 137L343 146L347 160L348 168L349 191V205L330 209H325L313 188L307 173L304 159V147L307 123L308 120Z"
        fill="#97C03B"
      />
      <path
        d="M199 164L203 166L211 174L222 183L233 192L250 204L270 216L279 221L278 223L256 231L251 230L238 223L231 217L218 200L210 186L202 169L199 164Z"
        fill="#80A03E"
      />
      <path
        d="M396 5L399 6L401 20V65L399 84L397 81L390 62L384 52L375 42L367 35L369 31L379 22L396 5Z"
        fill="#96C03B"
      />
      <path
        d="M239 308H244L247 312L246 321L241 326H234L232 323V315L237 309L239 308Z"
        fill="#F9B47B"
      />
      <path
        d="M213 338L218 339L220 341L219 348L215 352L210 351L208 349V343L213 338Z"
        fill="#F9AA65"
      />
      <path
        d="M172 305H177L179 308L178 315L175 318H170L168 315L169 308L172 305Z"
        fill="#F9B27A"
      />
      <path
        d="M196 313L201 314L202 316V322L197 327L193 326L192 324V318L196 313Z"
        fill="#F8A765"
      />
      <path
        d="M162 356H167L168 357V364L165 367L161 366L160 365V359L162 356Z"
        fill="#F8A152"
      />
      <path
        d="M282 271L287 272L286 278L283 281H280L279 275L282 271Z"
        fill="#FAC7A1"
      />
      <path
        d="M203 294L208 295L207 302L205 304L201 303V296L203 294Z"
        fill="#F9B078"
      />
    </SvgIcon>
  );
};

export default OjieThumbsUpIcon;
